"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStyles = void 0;
var tslib_1 = require("tslib");
var Styling_1 = require("../../Styling");
var Utilities_1 = require("../../Utilities");
var BaseButton_styles_1 = require("../Button/BaseButton.styles");
exports.getStyles = (0, Utilities_1.memoizeFunction)(function (theme, className, customStyles) {
    var baseButtonStyles = (0, BaseButton_styles_1.getStyles)(theme);
    var customButtonStyles = (0, Styling_1.concatStyleSets)(baseButtonStyles, customStyles);
    return tslib_1.__assign(tslib_1.__assign({}, customButtonStyles), { root: [baseButtonStyles.root, className, theme.fonts.medium, customStyles && customStyles.root] });
});
//# sourceMappingURL=FacepileButton.styles.js.map